import { Link } from 'react-router-dom';

export default function Impressum() {
  return (
    <main className="min-h-screen bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12 xl:px-16 py-12 md:py-20">
        <div className="max-w-3xl mx-auto">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium mb-8 cursor-pointer"
          >
            <i className="ri-arrow-left-line" />
            Zurück zur Startseite
          </Link>

          <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-8">
            Impressum
          </h1>

          <div className="space-y-8 text-foreground-700 leading-relaxed">
            <section>
              <h2 className="text-lg font-semibold text-foreground-900 mb-3">
                Angaben gemäß § 5 TMG
              </h2>
              <p className="text-sm">
                Haus Dornumersiel<br />
                Musterstraße 1<br />
                26553 Dornumersiel<br />
                Deutschland
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-foreground-900 mb-3">
                Vertreten durch
              </h2>
              <p className="text-sm">
                Max Mustermann (Eigentümer)
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-foreground-900 mb-3">
                Kontakt
              </h2>
              <p className="text-sm">
                Telefon: +49 (0) 4933 / 12345<br />
                E-Mail: info@haus-dornumersiel.de
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-foreground-900 mb-3">
                Umsatzsteuer-ID
              </h2>
              <p className="text-sm">
                Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
                DE123456789
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-foreground-900 mb-3">
                Streitschlichtung
              </h2>
              <p className="text-sm">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
                <a
                  href="https://ec.europa.eu/consumers/odr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary-600 hover:underline"
                >
                  https://ec.europa.eu/consumers/odr
                </a>.
                <br />
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-foreground-900 mb-3">
                Haftung für Inhalte
              </h2>
              <p className="text-sm">
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-foreground-900 mb-3">
                Haftung für Links
              </h2>
              <p className="text-sm">
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-foreground-900 mb-3">
                Urheberrecht
              </h2>
              <p className="text-sm">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
              </p>
            </section>
          </div>
        </div>
      </div>
    </main>
  );
}